import type { PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http'
import { injectable } from '@patsnap/tahiti-core/shared/inversify'
import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http'
import type {
    IPatentLayoutApi,
    PatentLayoutRequestType,
    PatentLayoutResponseType,
} from '../patent-layout-api'

@injectable()
export class PatentLayoutApiImpl extends PsHttpService implements IPatentLayoutApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/core-eurekals-api/eurekals_agent/1.0`,
        }
    }

    getLayoutByPatent(params: PatentLayoutRequestType) {
        return this.post<PatSnapCommonResponseData<PatentLayoutResponseType>>({
            url: '/patent/layout_ocsr',
            data: params,
        }).then(res => {
            return (res || {}) as unknown as PatentLayoutResponseType
        })
    }
}
